<template>
  <div class="page-wrapper">
    <div class="container-fluid p-0">
      <!-- login page start-->
      <div class="authentication-main">
        <div class="row">
          <div class="col-md-12">
            <div class="auth-innerright">
              <div class="authentication-box">
                <div class="text-center">
                  <img alt id="infralogo" src="../assets/infralogo.png" />
                </div>
                <div class="card mt-4">
                  <div class="card-body">
                    <div class="text-center">
                      <h4>Neues Passwort setzen</h4>
                      <h6>Bitte geben Sie Ihr gewünschtes Passwort ein.</h6>
                    </div>
                    <form class="theme-form">
                      <div class="form-group">
                        <label class="col-form-label" for="pwOnce">Passwort</label>
                        <input class="form-control" type="password" name="pwOnce" id="pwOnce" v-model="pwOnce" />
                      </div>
                      <div class="form-group">
                        <label class="col-form-label" for="pwTwice">Wiederholung</label>
                        <input class="form-control" type="password" name="pwTwice" id="pwTwice" v-model="pwTwice" />
                      </div>
                      <div class="btn btn-primary" @click.prevent="validatePw">Passwort zurücksetzen</div>
                    </form>
                    <transition name="fade">
                      <div class="errors text-center" v-if="pwNotSame">
                        <div>Passwörter stimmen nicht überein.</div>
                      </div>
                    </transition>
                    <transition name="fade">
                      <div class="errors text-center" v-if="pwEmpty">
                        <div>Bitte füllen Sie beide Felder aus.</div>
                      </div>
                    </transition>
                    <transition name="fade">
                      <div class="errors text-center" v-if="tokenEmpty">
                        <div>Token nicht gefunden, bitte Passwortreset erneut anfordern.</div>
                      </div>
                    </transition>
                    <transition name="fade">
                      <div class="errors text-center" v-if="pwResetError">
                        <div>Fehler beim Zurücksetzen des Passworts.</div>
                      </div>
                    </transition>
                    <transition name="fade">
                      <div class="errors text-center" v-if="pwComplexity">
                        <div>Ihr Passwort benötigt eine Länge von mindestens 8 Zeichen.</div>
                      </div>
                    </transition>
                    <div class="goodnews" v-if="pwResetSuccess">Ihr Passwort wurde erfolgreich zurückgesetzt, leite Sie weiter...</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- login page end-->
    </div>
  </div>
</template>

<script>
export default {
  name: "resetPassword",
  data: function() {
    return {
      pwreset_token: false,
      pwOnce: "",
      pwTwice: "",
      pwNotSame: false,
      pwEmpty: false,
      pwComplexity: false,
      tokenEmpty: false,
      pwResetError: false,
      pwResetSuccess: false,
    };
  },
  created: function() {
    this.pwreset_token = this.$route.query.token;
  },
  methods: {
    async validatePw() {
      let samePw = this.pwOnce === this.pwTwice;
      let emptyPw = this.pwOnce.length && this.pwTwice.length ? false : true;
      let tokenEmpty = this.pwreset_token ? false : true;
      //let pwComplexity = this.pwOnce.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,}$/);
      let pwComplexity = this.pwOnce.length >= 8;

      if (!samePw) {
        this.pwNotSame = true;
        setTimeout(() => {
          this.pwNotSame = false;
        }, 4000);
        return;
      }

      if (emptyPw) {
        this.pwEmpty = true;
        setTimeout(() => {
          this.pwEmpty = false;
        }, 4000);
        return;
      }

      if (tokenEmpty) {
        this.tokenEmpty = true;
        setTimeout(() => {
          this.tokenEmpty = false;
        }, 4000);
      }

      if (!pwComplexity) {
        this.pwComplexity = true;
        setTimeout(() => {
          this.pwComplexity = false;
        }, 4000);
      }

      if (samePw && !emptyPw && !tokenEmpty && pwComplexity) {
        const payload = {
          token: this.pwreset_token,
          password: this.pwOnce,
        };
        try {
          await this.$store.dispatch("auth/resetPw", payload);
          this.pwResetSuccess = true;
          setTimeout(() => {
            this.$router.push("/");
          }, 6000);
        } catch (error) {
          console.log("reset error");
          this.pwResetError = true;
          setTimeout(() => {
            this.pwResetError = false;
          }, 4000);
        }
      }
    },
  },
};
</script>

<style></style>
